<script setup>
const TAG_NAME = 'Printemps pour la planète'
const { informations, fetchInformations } = useOperationNationale(TAG_NAME)

const daysLeft =
  Math.floor((new Date(`${new Date().getFullYear()}-05-01`) - new Date()) / (1000 * 60 * 60 * 24)) +
  1

onMounted(() => {
  fetchInformations()
})
</script>

<template>
  <div
    id="mission-count-down-printemps-pour-la-planete"
    class="relative p-6 w-full bg-[#F5F7FF] border border-[#BDCDFF] rounded shadow-lg"
  >
    <div class="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
      <div class="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
        <img
          src="/images/stickers/sticker-printemps-pour-la-planete.svg"
          alt="Printemps pour la planète"
          width="120"
          height="120"
          class="flex-none w-[96px] h-[96px] sm:w-[120px] sm:h-[120px]"
        />
        <div class="">
          <div class="text-[#161616] text-base mb-1">
            En proposant votre aide pour cette mission, vous participez au mouvement
            <strong>Printemps pour la planète</strong>.
          </div>
          <div v-if="informations.participations_count > 0" class="text-[#666666] text-sm">
            {{
              $filters.pluralize(
                informations.participations_count,
                'bénévole participe',
                'bénévoles participent'
              )
            }}
            déjà !
          </div>
        </div>
      </div>
      <div v-if="daysLeft > 0" class="border border-[#E3E3FD] rounded p-4 sm:p-6">
        <div class="sm:hidden text-sm text-[#666666] text-center">
          Plus que
          <span class="font-bold text-base text-[#161616]">{{
            $filters.pluralize(daysLeft, 'jour', 'jours')
          }}</span>
          pour participer
        </div>
        <div class="hidden sm:block sm:w-[104px] text-center">
          <div class="text-[#666666] text-sm">Plus que</div>
          <div class="text-[#161616] font-bold text-2xl">
            {{ $filters.pluralize(daysLeft, 'jour', 'jours') }}
          </div>
          <div class="text-[#666666] text-sm">pour participer</div>
        </div>
      </div>
    </div>
  </div>
</template>
